import React from "react";
import { Select } from "antd";
import { Row, Col, Form, Button } from "shards-react";
import { history } from "helpers/history";
import { filterObjectToQueryString } from "helpers/functions";

const Option = Select.Option;

export default class ClientFilter extends React.Component {
  componentDidMount() {
    const { formState, fetchClientFormState } = this.props;
    !formState && fetchClientFormState();
  }

  selectSearch = (input, option) =>
    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  handleStateChange(_name, value) {
    const { setFilters, filters } = this.props;

    setFilters({ ...filters, [_name]: value });
  }
  filter() {
    const { fetchClients } = this.props;
    fetchClients(1);
  }
  render() {
    const { shortClients, filters, formState } = this.props;
    const Clients = shortClients || [];
    const Currencies = formState ? formState.currency : [];

    return (
      <Form>
        <Row form className="align-items-end invoice-filter">
          <Col md="3" className="form-group mb-0">
            <label className="text-muted d-block mb-2">Client:</label>
            <Select
              id="client-filter"
              showSearch
              filterOption={this.selectSearch}
              onChange={id => this.handleStateChange("id", id)}
              placeholder="Select client"
              value={filters.id || undefined}
            >
              <Option key={"client-filter-default"} value={undefined}>
                -
              </Option>
              {Clients.map(el => (
                <Option key={el.id}>{el.name}</Option>
              ))}
            </Select>
          </Col>
          <Col md="3" className="form-group mb-0">
            <label className="text-muted d-block mb-2">Currencies:</label>
            <Select
              id="client-currency-filter"
              showSearch
              filterOption={this.selectSearch}
              onChange={id => this.handleStateChange("currency_id", id)}
              placeholder="Select currency"
              value={filters.currency_id ? Number(filters.currency_id) : undefined}
            >
              <Option key={"client-filter-default"} value={undefined}>
                -
              </Option>
              {Currencies.map(el => (
                <Option key={el.id} value={el.id}>{el.short_name}</Option>
              ))}
            </Select>
          </Col>

          <Col md="auto" className="form-group mb-0">
            <Button
              outline
              theme="primary"
              className="btn_filter"
              onClick={() => {
                const { filters: params } = this.props;
                history.replace({
                  pathname: history.location.pathname,
                  search: filterObjectToQueryString(params)
                });
                this.filter();
              }}
            >
              Search
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}
